export default class AbstractDomElement {
    el;
    #hideClass = 'hide';

    constructor({ id, tag, classes }) {
        this.el = document.createElement(tag);
        this.setClasses(classes);
        this.setId(id);
    }

    setClasses(classes) {
        this.el.className = '';

        if (!classes?.length) return;
        this.addClasses(classes);
    }

    addClasses(classes = []) {
        classes.forEach((className) => {
            this.el.classList.add(className);
        });
    }

    setCssVariable(name, value) {
        this.el.style.setProperty(name, value);
    }

    setId(id) {
        if (!id) return;

        this.el.setAttribute('id', id);
    }

    removeClasses(classes = []) {
        classes.forEach((className) => {
            this.el.classList.remove(className);
        });
    }

    appendToParent(parentEl = document.getElementById('game')) {
        parentEl.appendChild(this.el);
    }

    setStyles(stylesObject) {
        Object.keys(stylesObject).forEach((key) => {
            this.el.style[key] = stylesObject[key];
        });
    }

    updateCssVariable(cssVarName, value) {
        this.el.style.setProperty(cssVarName, value);
    }

    hide() {
        this.addClasses([this.#hideClass]);
    }

    show() {
        this.removeClasses([this.#hideClass]);
    }

    remove() {
        this.el.remove();
    }
}
